import ApiService from '../ApiService'

const RoleService = {
    getRoles() {
        return ApiService.get('/role')
    },
    getOneRole(id) {
        return ApiService.get(`/role/${id}`)
    },
    createRole(roleName, id) {
        return ApiService.post('/role', { roleName, id })
    },
    getsId() {
        return ApiService.get('/role/getsId')
    },

    activeRole(data) {
        return ApiService.post(`/role/activate`, data)
    },

    desactiveRole(data) {
        return ApiService.post(`/role/inactivate`, data)
    },

    removeRole(data) {
        return ApiService.post(`/role/remove/`, data)
    }
}

export default RoleService;